import { useEffect, useState } from 'react';
import { OLAF } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { X_DISTANCE_FROM_SIDE } from '../constants/SidebarConstants';
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIconButton = styled(UIIconButton).withConfig({
  displayName: "CollapseButton__StyledIconButton",
  componentId: "ft86t9-0"
})(["height:40px;border-radius:50%;background:", ";z-index:10;span{font-weight:normal !important;}"], OLAF);
const CollapseButton = ({
  onClick,
  isLocked,
  collapsed,
  position,
  showTooltip,
  collapseButtonRef
}) => {
  const {
    topOffset,
    alignment
  } = position;
  const [tooltipDisabled, setTooltipDisabled] = useState(!showTooltip);
  useEffect(() => {
    setTooltipDisabled(collapsed || !showTooltip);
  }, [collapsed, showTooltip]);
  const xOffset = collapsed || alignment === 'right' ? {
    right: X_DISTANCE_FROM_SIDE
  } : {
    left: X_DISTANCE_FROM_SIDE
  };
  const onButtonClick = evt => {
    onClick();
    setTooltipDisabled(isLocked);
    evt.stopPropagation();
  };
  const iconName = !isLocked ? 'last' : 'first';
  const tooltipText = isLocked ? I18n.text('svh-workspace-ui-lib.navigation-sidebar.collapse-button.locked') : I18n.text('svh-workspace-ui-lib.navigation-sidebar.collapse-button.hovered');
  return /*#__PURE__*/_jsx("div", {
    className: "flex-column align-center",
    style: Object.assign({
      position: 'absolute'
    }, xOffset, {
      top: topOffset,
      transition: 'all 200ms cubic-bezier(0.42, 0, 0.58, 1)'
    }),
    ref: collapseButtonRef,
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: tooltipText,
      disabled: tooltipDisabled,
      children: /*#__PURE__*/_jsx(StyledIconButton, {
        "data-test-id": "view-sidebar-collapse-button",
        use: "transparent",
        onClick: onButtonClick,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: iconName
        })
      })
    })
  });
};
CollapseButton.displayName = 'CollapseButton';
export default CollapseButton;